export default {
  data () {
    return {
      isShowFilter: true,
      isDataPageLoading: true,
      modal: {
        show: false,
        campaignId: null,
        form: {
          title: {
            type: 'input',
            name: 'title',
            label: 'Campaign title',
            placeholder: 'Campaign title',
            value: null,
            class: 'col-12'
          },
          contractors: {
            type: 'slot',
            slotName: 'Contractors',
            name: 'contractors',
            values: [],
            forAll: true,
            options: [],
            class: 'col-12'
          },
          main_message: {
            type: 'input',
            name: 'main_message',
            label: 'Main message',
            placeholder: 'Main message',
            value: null,
            class: 'col-12'
          },
          bot_answer_option1_message: {
            type: 'input',
            name: 'bot_answer_option1_message',
            label: 'Bot answer option 1 message',
            placeholder: 'Bot answer option 1 message',
            value: null,
            class: 'col-12'
          },
          bot_answer_option2_message: {
            type: 'input',
            name: 'bot_answer_option2_message',
            label: 'Bot answer option 2 message',
            placeholder: 'Bot answer option 2 message',
            value: null,
            class: 'col-12'
          },
          bot_answer_option3_message: {
            type: 'input',
            name: 'bot_answer_option3_message',
            label: 'Bot answer option 3 message',
            placeholder: 'Bot answer option 3 message',
            value: null,
            class: 'col-12'
          }
        }
      },
      table: {
        slots: {
          contractors: {
            name: 'contractors'
          }
        },
        fields: [
          {
            key: 'title',
            label: 'Title',
            sortable: true
          },
          {
            key: 'contractors',
            label: 'Chosen Contractors'
          },
          {
            key: 'main_message',
            label: 'Main message'
          },
          {
            key: 'bot_answer_option1_message',
            label: 'Answer option 1'
          },
          {
            key: 'bot_answer_option2_message',
            label: 'Answer option 2'
          },
          {
            key: 'bot_answer_option3_message',
            label: 'Answer option 3'
          },
          {
            key: 'actions',
            label: 'Actions'
          }
        ],
        actions: [
          { label: 'Edit', event: 'edit', show: true },
          { label: 'Delete', event: 'remove', show: true },
          { label: 'Start', event: 'start', show: true }
        ],
        params: {
          filters: null,
          sorting: null,
          currentPage: '?page=1'
        }
      },
      filters: {
        'title': {
          type: 'input',
          name: 'title',
          label: 'Title',
          placeholder: 'Campaign title',
          value: null
        },
        'main_message': {
          type: 'input',
          name: 'main_message',
          label: 'Main message',
          placeholder: 'Main message',
          value: null
        }
      }
    }
  },
  computed: {},
  methods: {
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    showModal (data) {
      this.modal.show = true
      if (data) {
        this.modal.campaignId = data.id
        this.modal.form.title.value = data.title
        this.modal.form.contractors.forAll = !!data.for_all
        const contractors = data.contractors.map((telegram) => telegram.id)
        this.modal.form.contractors.values = this.modal.form.contractors.options.filter((option) => contractors.includes(option.id))
        this.modal.form.main_message.value = data.main_message
        this.modal.form.bot_answer_option1_message.value = data.bot_answer_option1_message
        this.modal.form.bot_answer_option2_message.value = data.bot_answer_option2_message
        this.modal.form.bot_answer_option3_message.value = data.bot_answer_option3_message
      }
    },
    hideModal () {
      this.modal.show = false
      this.modal.campaignId = null
      this.modal.form.title.value = null
      this.modal.form.contractors.forAll = false
      this.modal.form.main_message.value = null
      this.modal.form.bot_answer_option1_message.value = null
      this.modal.form.bot_answer_option2_message.value = null
      this.modal.form.bot_answer_option3_message.value = null
    },
    setParamsFilters (data) {
      const filters = Object.values(data).reduce(function (state, current) {
        if (current['value']) {
          const value = typeof current['value'] === 'object'
            ? current['value'][current['valueField']] : current['value']
          state += `&filter[${current.name}]=${value}`
        }
        return state
      }, '')

      this.table.params.filters = filters || null
    },
    setParamsSort (sortDesc, sortBy) {
      if (sortBy) {
        const sortDirection = sortDesc ? 'desc' : 'asc'
        this.table.params.sorting = `&sort[${sortBy}]=${sortDirection}`
      }
    },
    setParamsCurrentPage (currentPage = 1) {
      this.table.params.currentPage = `?page=${currentPage}`
    },
    prepareDataForRequest (fields) {
      let data = {}

      for (let key in fields) {
        const field = fields[key]
        const name = field['name']
        let value = field['value']
        if (name === 'contractors') {
          data['for_all'] = field.forAll
          data[name] = field.forAll ? [] : Object.values(field.values.map((telegram) => telegram.id))
        } else if (Object.prototype.toString.call(value) === '[object Array]' && value) {
          for (let valueItemKey in value) {
            const valueItemValue = value[valueItemKey]
            data[name] = data[name] ?? []
            data[name][valueItemKey] = (typeof valueItemValue === 'object' && valueItemValue && field['valueField']) ? valueItemValue[field['valueField']] : valueItemValue
          }
        } else {
          data[name] = (typeof value === 'object' && value && field['valueField']) ? value[field['valueField']] : value
        }
      }

      return data
    }
  }
}
